import {
  CLOSE_BLOCKED_SEATS_MODAL,
  OPEN_BLOCKED_SEATS_MODAL,
  SET_BLOCKED_SEATS,
  ADD_BLOCKED_SEATS,
  REMOVE_BLOCKED_SEAT,
  CLEAR_BLOCKED_SEATS,
} from './types';
import { getBlockedSeatKey, mergeBlockedSeats } from './utils';

const initialState = {
  isBlockedSeatModalOpen: false,
  blockedSeats: [],
};

export default (state = initialState, { payload, type }) => {
  switch (type) {
  case REMOVE_BLOCKED_SEAT: {
    const key = getBlockedSeatKey(payload);

    return {
      ...state,
      blockedSeats: state.blockedSeats.filter((item) => getBlockedSeatKey(item) !== key),
    };
  }
  case ADD_BLOCKED_SEATS: {
    return {
      ...state,
      blockedSeats: mergeBlockedSeats(state.blockedSeats, payload),
    };
  }
  case CLEAR_BLOCKED_SEATS: {
    return {
      ...state,
      blockedSeats: [],
    };
  }
  case SET_BLOCKED_SEATS: {
    return {
      ...state,
      blockedSeats: payload || [],
    };
  }
  case CLOSE_BLOCKED_SEATS_MODAL: {
    return {
      ...state,
      isBlockedSeatModalOpen: false,
    };
  }
  case OPEN_BLOCKED_SEATS_MODAL: {
    return {
      ...state,
      isBlockedSeatModalOpen: true,
    };
  }
  default: {
    return state;
  }
  }
};
